import { Divider } from '@blueprintjs/core';

import { useConfig } from '@f/hooks';

import cls from './Footer.module.scss';

export function Footer() {
  const config = useConfig();

  const tcUrl = config.document.termsAndConditions.url;
  const docsUrl = `${config.hubUrl}/docs/retro/`;

  return (
    <footer className={cls.footer}>
      <ul className={cls.elements}>
        <li>© {new Date().getFullYear()} Molecule.one</li>
        <Divider className={cls.divider} tagName="li" />
        <li>v{import.meta.env.VITE_APP_VERSION}</li>
        <Divider className={cls.divider} tagName="li" />
        <li>
          <a className={cls.link} href={tcUrl} target="_blank" rel="noopener noreferrer">
            Terms and Conditions of Use
          </a>
        </li>
        <Divider className={cls.divider} tagName="li" />
        <li>
          <a className={cls.link} href={docsUrl} target="_blank" rel="noopener noreferrer">
            User Guides
          </a>
        </li>
      </ul>
    </footer>
  );
}
